import { Box, Grid, Typography, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import image2 from "../../../../assets/image.png";
import image1 from "../../../../assets/sportsday.png";

const AboutUs = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      id="pillars"
      sx={{
        padding: "10px",
        marginTop: "50px",
        textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: "bold",
          fontSize: { xs: "18px", md: "30px" },
          marginBottom: "2px",
        }}
      >
        Key Pillars of Our Podar Juniors
      </Typography>
      <Typography sx={{ marginBottom: "50px", mt: 1 }}>
        Pillars of Promise - Building Bright Futures Together.
      </Typography>

      {/* Tab buttons */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        centered={window.innerWidth >= 600} // Center tabs only on desktop
        variant={window.innerWidth < 600 ? "scrollable" : "standard"} // Enable scrollable tabs on mobile
        scrollButtons={window.innerWidth < 600 ? "auto" : false} // Show scroll buttons on mobile
        sx={{
          marginBottom: "8px",
          gap: 5,
          width: "100%", // Make tabs take full width
        }}
      >
        {["Innovation", "Nurturing", "Inspiring", "Dynamic", "Engaging"].map(
          (label, index) => (
            <Tab
              key={index}
              label={label}
              sx={{
                backgroundColor: "#1d67ab",
                color: "white",
                whiteSpace: "nowrap", // Prevent text wrapping
                minWidth: "100px", // Minimum width for tabs
                "&.Mui-selected": {
                  backgroundColor: "#fccd0c",
                  color: index === 4 ? "black" : "white", // Different color for "Engaging" tab
                },
                marginRight: "10px", // Reduce gap between tabs for better mobile spacing
              }}
            />
          )
        )}
      </Tabs>

      {/* Content based on selected tab */}
      <Grid container spacing={4} sx={{ mt: 5 }}>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${image2})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
              height: { xs: "250px", md: "350px" },
              maxWidth: "500px",
              margin: "0 auto",
              borderRadius: "20px",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.2)",
              },
            }}
          />
        </Grid>

        <Grid
          item
          xs={12}
          md={6}
          sx={{
            padding: { xs: 2, md: 6 },
            textAlign: { xs: "center", md: "left" },
          }}
        >
          {/* Tab content */}
          <Box sx={{ marginTop: "20px", textAlign: "left" }}>
            {selectedTab === 0 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "bold",
                    mt: 3,
                    mb: 1,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Innovation
                </Typography>
                <Typography
                  sx={{
                    textAlign: "justify",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  Innovation is the cornerstone of our approach, fostering a
                  culture of creativity and forward-thinking. Through
                  cutting-edge teaching methods and curriculum design, we
                  continuously strive to push boundaries and ignite curiosity,
                  preparing our students for a rapidly evolving world.
                </Typography>

                <Box sx={{ ml: -3, mb: 1, mt: 3 }}>
                  <ul>
                    <li style={{ marginBottom: "8px", fontSize: 16 }}>
                      Modern teaching with interactive tech.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      STEM activities for critical thinking.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Curiosity-driven curriculum.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Digital tools for enhanced learning.
                    </li>
                  </ul>
                </Box>
              </Box>
            )}
            {selectedTab === 1 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "bold",
                    mt: 3,
                    mb: 1,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Nurturing
                </Typography>
                <Typography
                  sx={{
                    textAlign: "justify",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  Nurturing lies at the heart of our ethos, where every child is
                  embraced with warmth and support. We cultivate a caring
                  environment that nurtures not only academic growth but also
                  emotional well-being, fostering confidence and resilience in
                  our students.
                </Typography>
                <Box sx={{ ml: -3, mb: 1, mt: 3 }}>
                  <ul>
                    <li style={{ marginBottom: "8px", fontSize: 16 }}>
                      Safe, caring, and supportive environment.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Focus on emotional well-being.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Strong teacher-student bonding.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Balanced routine for holistic growth.
                    </li>
                  </ul>
                </Box>
              </Box>
            )}
            {selectedTab === 2 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "bold",
                    mt: 3,
                    mb: 1,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Inspiring
                </Typography>
                <Typography
                  sx={{
                    textAlign: "justify",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  Inspiring our students to reach for the stars, we cultivate an
                  environment where curiosity thrives and dreams take flight.
                  Through captivating experiences and role models, we ignite a
                  passion for learning, empowering each child to explore their
                  potential and pursue their aspirations.
                </Typography>
                <Box sx={{ ml: -3, mb: 1, mt: 3 }}>
                  <ul>
                    <li style={{ marginBottom: "8px", fontSize: 16 }}>
                      Creativity through art, music & play.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Storytelling to instill values.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Encouraging self-expression & confidence.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Celebrating each child’s uniqueness.
                    </li>
                  </ul>
                </Box>
              </Box>
            )}
            {selectedTab === 3 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "bold",
                    mt: 3,
                    mb: 1,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Dynamic
                </Typography>
                <Typography
                  sx={{
                    textAlign: "justify",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  At our school, dynamism fuels every aspect of learning,
                  ensuring an environment that adapts and evolves with our
                  students. From interactive lessons to diverse extracurricular
                  activities, we embrace change and innovation to keep education
                  lively, relevant, and engaging.
                </Typography>
                <Box sx={{ ml: -3, mb: 1, mt: 3 }}>
                  <ul>
                    <li style={{ marginBottom: "8px", fontSize: 16 }}>
                      Thematic and interest-based learning.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Outdoor & movement activities.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Teamwork and social skills.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Balance of structure and free play.
                    </li>
                  </ul>
                </Box>
              </Box>
            )}
            {selectedTab === 4 && (
              <Box>
                <Typography
                  sx={{
                    fontSize: { xs: "16px", md: "20px" },
                    fontWeight: "bold",
                    mt: 3,
                    mb: 1,
                    textAlign: { xs: "center", md: "left" },
                  }}
                >
                  Engaging
                </Typography>
                <Typography
                  sx={{
                    textAlign: "justify",
                    fontSize: { xs: "14px", md: "16px" },
                  }}
                >
                  In our vibrant community, engagement is more than a
                  buzzword—it's a way of life. Through interactive lessons,
                  collaborative projects, and inclusive activities, we ignite a
                  love for learning that captivates our students' minds and
                  hearts, ensuring every day is filled with excitement and
                  discovery.
                </Typography>
                <Box sx={{ ml: -3, mb: 1, mt: 3 }}>
                  <ul>
                    <li style={{ marginBottom: "8px", fontSize: 16 }}>
                      Hands-on, play-based learning.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Interactive storytelling & role-play.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Sensory experiences for exploration.
                    </li>
                    <li style={{ marginBottom: "8px" }}>
                      Strong home-school connection.
                    </li>
                  </ul>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AboutUs;
